/* eslint-disable functional/no-let */

const LDJSON_SELECTOR = 'script[type="application/ld+json"]';

interface BaseJsonLdObject {
  '@type': string;
  keywords?: string[];
  articleBody?: string;
}

export interface NewsArticle extends BaseJsonLdObject {
  '@type': 'NewsArticle';
}

export interface GraphLDJson {
  '@graph': NewsArticle[];
}

export type JsonLdObject = GraphLDJson | NewsArticle;

export function isGraphLDJson(json: JsonLdObject): json is GraphLDJson {
  return '@graph' in json;
}

export function getContextKeywords(): string[] {
  const scripts = document.querySelectorAll<HTMLScriptElement>(LDJSON_SELECTOR);

  const keywords: string[] = [];

  if (!scripts) {
    return keywords;
  }

  const appendKeywordsFromEntry = (entry: Readonly<NewsArticle>): void => {
    if (entry['@type'] !== 'NewsArticle') {
      return;
    }
    keywords.push(...(entry.keywords || []));
  };

  scripts.forEach(s => {
    try {
      const json = JSON.parse(s.innerText) as JsonLdObject;

      if (isGraphLDJson(json)) {
        json['@graph'].forEach(entry => {
          appendKeywordsFromEntry(entry);
        });
      } else if (Array.isArray(json)) {
        json.forEach(entry => {
          appendKeywordsFromEntry(entry as NewsArticle);
        });
      } else {
        appendKeywordsFromEntry(json);
      }
    } catch {
      // continue
    }
  });

  return keywords;
}

export function getContextCategory(): string {
  const scripts = document.querySelectorAll<HTMLScriptElement>(LDJSON_SELECTOR);

  let category = 'Unknown';

  if (!scripts) {
    return category;
  }

  const guessCategory = (entry: Readonly<NewsArticle>): string | null => {
    const type = entry['@type'] as string | undefined;

    if (type === 'NewsArticle') {
      return 'News';
    }

    return null;
  };

  scripts.forEach(s => {
    try {
      const json = JSON.parse(s.innerText) as JsonLdObject;

      if (isGraphLDJson(json)) {
        json['@graph'].forEach(entry => {
          category = guessCategory(entry) ?? category;
        });
      } else if (Array.isArray(json)) {
        json.forEach(entry => {
          category = guessCategory(entry as NewsArticle) ?? category;
        });
      } else {
        category = guessCategory(json) ?? category;
      }
    } catch {
      // continue;
    }
  });

  return category;
}
